import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { AgGridArgs, useWorkspaceTableAgGridOptions } from "./hooks";

export type ArenaAccessRow = {
  id: string;
  arenaName: string;
  arenaId: string;
  arenaDomain: string;
  roleGroupName: string;
  active: boolean;
  accessType: string;
  accessVia?: string;
  endDate: string;
  lastAccess: string;
  login: {
    arenaId: string;
    adminUserId: number;
    active: boolean;
  };
};

type Props = {
  onGridReady: (event: AgGrid.GridReadyEvent<ArenaAccessRow>) => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
  arenaAccessRows: ArenaAccessRow[];
} & AgGridArgs;

export const WorkspaceTable = ({
  onGridReady,
  onFilterChanged,
  domLayout,
  arenaAccessRows,
  paginationPageSizeSelector,
  paginationPageSize,
  FinalElement,
  finalColumnText,
  cellRendererParams,
  showAccessVia,
}: Props) => {
  const { colDefs } = useWorkspaceTableAgGridOptions({
    domLayout,
    FinalElement,
    finalColumnText,
    cellRendererParams,
    showAccessVia,
  });
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      domLayout,
      paginationPageSize,
      paginationPageSizeSelector,
      overlayNoRowsTemplate: "No workspaces found",
    },
  });

  return (
    <Grid
      onGridReady={onGridReady}
      rowData={arenaAccessRows}
      getRowId={(params) => params.data.id}
      columnDefs={colDefs}
      gridOptions={gridOptions}
      suppressColumnVirtualisation={true}
      suppressRowVirtualisation={true}
      onFilterChanged={onFilterChanged}
    />
  );
};
